import React, { useEffect } from "react";
import LegalLayout from "./LegalLayout";
import { useLanguage } from "../../i18n/LanguageContext";

const ImpressumPage = () => {
  const { t } = useLanguage();
  useEffect(() => {
    document.title = `${t("legal.impressum.title")} - Reflecta`;
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", t("legal.impressum.metaDescription"));
    let robots = document.querySelector('meta[name="robots"]');
    if (!robots) {
      robots = document.createElement("meta");
      robots.setAttribute("name", "robots");
      document.head.appendChild(robots);
    }
    robots.setAttribute("content", "index,follow");
  }, [t]);

  return (
    <LegalLayout title={t("legal.impressum.title")}>
      <h2 className="text-xl font-semibold mt-8">Angaben gemäß § 5 TMG</h2>
      <p>
        Elaspix Unternehmergesellschaft (haftungsbeschränkt)
        <br />
        Schliffkopfstraße 25
        <br />
        68163 Mannheim
        <br />
        Deutschland
      </p>

      <h2 className="text-xl font-semibold mt-8">Geschäftsführer</h2>
      <p>Dr. Tobias Günther</p>

      <h2 className="text-xl font-semibold mt-8">Kontakt</h2>
      <p>
        E-Mail:{" "}
        <a href="mailto:info@elaspix.de" className="text-purple-700 hover:underline">
          info@elaspix.de
        </a>
      </p>

      <h2 className="text-xl font-semibold mt-8">Handelsregister</h2>
      <p>
        Registergericht: Amtsgericht Mannheim
        <br />
        Registernummer: HRB 705891
      </p>

      <h2 className="text-xl font-semibold mt-8">Haftungsausschluss</h2>
      <p>
        Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung
        für die Inhalte externer Links. Für den Inhalt der verlinkten Seiten
        sind ausschließlich deren Betreiber verantwortlich.
      </p>
    </LegalLayout>
  );
};

export default ImpressumPage;
